import React from "react";

const SavingGrowth = () => {
    return (
        <div>
            <div className="absolute lg:-left-32 md:-left-32 sm:-left-[2rem] -left-[2rem] top-8 lg:w-52 md:w-52 sm:w-[11rem] w-[11rem] bg-white border border-[#fbecf9] shadow-xl z-10 rounded-xl bg-opacity-85">
                <div className="p-6">
                    <h3 className="font-semibold text-navy-900 text-lg mb-4 text-center text-[#6540b2]">Saving growth</h3>
                    <div className="relative w-full aspect-square">
                        <svg className="w-full h-full" viewBox="0 0 100 100">
                            <circle cx="50" cy="50" r="45" fill="none" stroke="#f0f0f0" strokeWidth="8" />
                            <circle cx="50" cy="50" r="45" fill="none" stroke="#e83f3b" strokeWidth="8" strokeLinecap="round" strokeDasharray="282.7" strokeDashoffset="239.3" transform="rotate(-90 50 50)" />
                        </svg>
                        <div className="absolute inset-0 flex items-center justify-center">
                            <span className="text-3xl font-bold text-[#6540b2]">15.4%</span>
                        </div>
                    </div>
                    <div className="flex justify-between mt-4 text-md font-bold text-[#6540b2]">
                        <span>0%</span>
                        <span>80%</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SavingGrowth;
